import React from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button, Space } from "antd";
import { CloseCircleOutlined, HomeOutlined, ShoppingOutlined } from "@ant-design/icons";
import "./payment-error.css";

const PaymentError = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-error-container">
      <Result
        status="error"
        icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
        title="Ошибка при оплате"
        subTitle="Произошла ошибка при обработке платежа. Пожалуйста, попробуйте еще раз или обратитесь в службу поддержки."
        extra={[
          <Space key="actions" size="middle">
            <Button
              type="primary"
              icon={<ShoppingOutlined />}
              onClick={() => navigate("/sales/unpaid")}
            >
              К оплате
            </Button>
            <Button
              icon={<HomeOutlined />}
              onClick={() => navigate("/")}
            >
              На главную
            </Button>
          </Space>,
        ]}
      />
    </div>
  );
};

export default PaymentError;
